import { useState, useEffect } from 'react';
import { container } from '@/di';
import { TYPES } from '@/di/tokens';
import { ListPlansAction } from '@/application/actions';
import { Plan } from '@/domain/entities/Plan';

export const usePlans = () => {
  const [plans, setPlans] = useState<Plan[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const loadPlans = async () => {
    setIsLoading(true);
    setError(null);
    try {
      const action = container.get<ListPlansAction>(TYPES.ListPlansAction);
      const result = await action.execute();
      setPlans(result);
    } catch (err) {
      const error = err instanceof Error ? err : new Error('Failed to load plans');
      setError(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    loadPlans();
  }, []);

  return { plans, isLoading, error, refetch: loadPlans };
};
